/* tslint:disable */

/**
 */
export class Firmware {
    path?: string;
    id?: number;
    server_ip?: string;
    username?: string;
    password?: string;
    device_model_id?: number;
    version?: number;
    filename?: string;
    created_at?: string;
    updated_at?: string;
    note?: string;
}
